import { Component, type ErrorInfo, type ReactNode } from 'react'
import { ErrorState } from '@/components/states'

/**
 * A render-time crash must not leave a blank page. The boundary shows the same
 * error treatment as a failed request (§14) and offers a reload.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: unknown }> {
  override state = { error: null as unknown }

  static getDerivedStateFromError(error: unknown): { error: unknown } {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Unhandled render error', error, info.componentStack)
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="mx-auto max-w-content px-4 py-20">
          <ErrorState error={this.state.error} onRetry={() => window.location.reload()} />
        </div>
      )
    }
    return this.props.children
  }
}
